import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, IResultadoItemProdutos } from "../../../model";
import { Button, Classes, FormGroup, H5, InputGroup, Intent, Popover, Position, Tooltip } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import * as moment from "moment";
import BootstrapTable from 'react-bootstrap-table-next';
import { AppStore } from "../../../stores/AppStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { formatCnpj } from "../../../utils";
import { columns_nao_calculados } from "../../utils/TableDetalhamento"
import { toast } from "react-toastify";
const numeral = require("numeral");

var debounce = require('lodash.debounce');

interface Props {
  handleContestarLote: () => void;
  items: IResultadoItemProdutos[];
  modelo: string;
  empresa: IEmpresa;
  data: any;
}

interface State {
  handleContestarLote: () => void;
}

@observer
export class NaoContestadosTableRs extends React.Component<Props, State> {

  obs = observable({
    new_columns: columns_nao_calculados,
    viewing: {} as IResultadoItemProdutos,
    estado: "RS" as string,
    fetchOptions: {} as any
  })

  constructor(props) {
    super(props);

    this.state = {
      handleContestarLote: props.handleContestarLote,
    };

    this.obs.fetchOptions = debounce(this.handleQuery.bind(this), 800);

  }

  componentDidMount() {
    let temp_table: any = [];
    ResultadoStore.handldeItensProcessando();

    temp_table = [
      {
        dataField: 'contestar',
        text: 'Contestar',
        headerStyle: { width: '5%' },
        formatter: (cell, row) => {
          return (this.buttonFormatterContestar(cell, row))
        },
      },
    ]

    this.obs.new_columns = columns_nao_calculados.concat(temp_table)
  }

  buttonFormatterContestar = (cell, row) => {
    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];
    let contIntent = Intent.NONE;

    if (ResultadoStore.obs.itens_processando.indexOf(row.id) != -1) {
      return (
        <Tooltip
          content={"Processando"}
        >
          <img src="/images/icone-relogio.png" width={30} />
        </Tooltip>
      )
    }

    return (
      <>
        {AppStore.obs1.usuario &&
          (
            <Tooltip content={"Contestar"} position="top">
              <MDBBtn
                color="default"
                intent={contIntent}
                rounded
                size="sm"
                onClick={() => this.handleContest(row.any_item)}
                disabled={niveis_acesso.indexOf("c2") == -1}
                // || row.chave.slice(0, 2) == "15"}
              >
                <img src="/images/contestar.png" width={20} />
              </MDBBtn>
            </Tooltip>
          )}
      </>
    );
  };

  async handleQuery() {

    await ResultadoStore.handleResultMemoriaRsFiltered(ResultadoStore.obs.page_produto_rs, this.obs.estado);

  }

  async handleQueryFilters(e) {

    ResultadoStore.obs.page_produto_rs = 1

    this.obs.fetchOptions()

  }

  handleContest(item: IResultadoItemProdutos) {
    ResultadoStore.obs.estado = this.obs.estado
    AppStore.setContestarProduto(item);
  }

  handleView(item: IResultadoItemProdutos) {
    this.obs.viewing = item;
  }

  handleViewClose = () => {
    this.obs.viewing = null;
  };

  handleContestarTodos() {
    ResultadoStore.selectAllContestarLoteRsNaoCalculados();
    ResultadoStore.obs.contestar_todos = true;
    ResultadoStore.obs.estado = this.obs.estado
    this.state.handleContestarLote();
  }

  onSelect = async (item, checked) => {

    if (checked) {

      const aliquotasItem = item.contestar.aliquota_icms_origem

      if (ResultadoStore.obs.contestarItems.length > 0) {

        const primeira = ResultadoStore.obs.contestarItems[0];
        const aliquotasPrimeira = primeira.aliquota_icms_origem

        if (aliquotasItem !== aliquotasPrimeira) {
          toast.warn("Este item possui alíquotas diferentes do primeiro item selecionado!", {})
          return;
        }

      }

      let data = {
        id: item.id,
        data: item.data,
        produtos: item.contestar.produtos,
        aliquota_icms_origem: item.contestar.aliquota_icms_origem,
      }

      ResultadoStore.setContestarItems(data);
    } else {
      ResultadoStore.deleteByIdContestarItems(item.id);
    }
  }

  onSelectAll = async (isSelect, rows) => {
    if (isSelect) {
      const primeiraAliquotas = rows[0].contestar.aliquota_icms_origem

      const itensFiltrados = rows.filter(produto => {

        const aliquotas = produto.contestar.aliquota_icms_origem

        if (aliquotas !== primeiraAliquotas) return false;

        return true;

      });

      let data = itensFiltrados?.map(value => {
        return {
          id: value.id,
          data: value.data,
          produtos: value.contestar.produtos,
          aliquota_icms_origem: value.contestar.aliquota_icms_origem,
        }
      })
      ResultadoStore.setContestarItemsListNao(data);
    } else {
      ResultadoStore.resetContestarItems();
    }
  };

  handleContestar() {
    ResultadoStore.obs.estado = this.obs.estado;

    this.state.handleContestarLote()
  }

  public render() {
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];
    let selectedItemCaption = ResultadoStore.selectedCount == 1 ? "item" : "itens";

    // let unselectable: string[] = [];

    // unselectable = [];

    let items_new = ResultadoStore.obs.result_memoria_rs?.map((item: IResultadoItemProdutos) => {

      // if (item.chave.slice(0, 2) == "15") {
      //   unselectable.push(item.id);
      // }

      return (
        {
          id: item._id,
          any_item: item,
          serie_nota: item.serie_nota + " / " + (item.num_nota ? item.num_nota : "") + " - " + item.num_item,
          data: moment(item.data).format("DD/MM/YYYY") + " " +
            moment(item.data).format("HH:mm"),
          ncm: item.ncm + " / " + (item.cest ? item.cest : "Sem CEST"),
          descricao: item.descricao.substring(0, 40).toUpperCase(),
          valor_produto: numeral((parseFloat(item.valor_produto) || 0)).format("0,0.00"),
          classificacao_nome:
            (item.classificacao_nome && item.classificacao_nome.startsWith("1"))
              ? item.classificacao_nome.substring(0, 4)
              : "Sem",
          info: item,
          contestar: item,
          cnpj: formatCnpj(item.empresa.cnpj),
          razao_social: item.empresa.razao_social,
          chave: item.chave,
          aliquota_icms_origem: item.aliquota_icms_origem,
          aliquota_icms_dest: item.aliquota_icms_dest
        }
      );
    });

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: false,
      columnWidth: "40px",
      style: { backgroundColor: '#e9f6ff' },
      onSelectAll: this.onSelectAll,
      selected: ResultadoStore.obs.contestarItems?.map(value => value.id),
      onSelect: this.onSelect,
      nonSelectable: ResultadoStore.obs.itens_processando,
    };

    const possuiAlgumFiltro = Object.values(ResultadoStore.obs.filters_nao_contestados).some(
      (valor) => valor.trim() !== ""
    );

    return (
      <>
        <div style={{width: "100%", display: "inline-block", marginBottom: 10}}>
          {AppStore.obs1.usuario && (<div style={{display: "flex"}}>
            <div style={{width: 300, float: 'left', marginRight: 10}}>
              <Tooltip
                content={`Contestar ${ResultadoStore.obs.contestar_todos
                  ? ResultadoStore.obs.result_memoria_rs_count
                  : ResultadoStore.selectedCount
                  } ${selectedItemCaption}`}
                disabled={ResultadoStore.selectedCount == 0}
              >
                <Button
                  className="btncontestarWidth"
                  disabled={ResultadoStore.selectedCount == 0 ||
                    niveis_acesso.indexOf("c2") == -1}
                  icon="issue"
                  onClick={() => this.handleContestar()}
                >
                  Contestar Selecionados
                </Button>
              </Tooltip>
            </div>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => this.handleQuery()}>Atualizar</MDBBtn>
          </div>)}

          {/* <div style={{ float: 'right' }}>
            <Tooltip content={!possuiAlgumFiltro ? "Filtro obrigatório!" : ""}>
              <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position={Position.LEFT}>
                <MDBBtn className="btnDefault btnBuscarNfe" disabled={!possuiAlgumFiltro || niveis_acesso.indexOf("c2") == -1}>
                  Selecionar Todos
                </MDBBtn>
                <div>
                  <H5>Confirmar Seleção</H5>
                  <p>Tem certeza que deseja selecionar todos os itens?</p>
                  <div style={{
                    display: "flex", justifyContent: "flex-end", marginTop: 15,
                  }}
                  >
                    <Button
                      className={Classes.POPOVER_DISMISS}
                      style={{ marginRight: 10 }}
                      onClick={() => ResultadoStore.resetContestarItems()}
                    >
                      Não
                    </Button>
                    <Button
                      intent="danger"
                      className={Classes.POPOVER_DISMISS}
                      onClick={() => this.handleContestarTodos()}
                    >
                      Sim
                    </Button>
                  </div>
                </div>
              </Popover>
            </Tooltip>
          </div> */}
        </div>

        <br/><br/>

        <thead>
          <tr>
            <th style={{ width: "5%" }}>
              <FormGroup label="Nota">
                <InputGroup placeholder="Filtrar Nota" value={ResultadoStore.obs.filters_nao_contestados.filterNota} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterNota = e.target.value)} />
              </FormGroup>
            </th>
  
            <th style={{ width: "5%" }}>
              <FormGroup label="Item">
                <InputGroup placeholder="Filtrar Item" value={ResultadoStore.obs.filters_nao_contestados.filterItem} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterItem = e.target.value)} />
              </FormGroup>
            </th>
  
            <th style={{ width: "5%" }}>
              <FormGroup label="NCM">
                <InputGroup placeholder="Filtrar Ncm" value={ResultadoStore.obs.filters_nao_contestados.filterNcm} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterNcm = e.target.value)} />
              </FormGroup>
            </th>
  
            <th style={{ width: "5%" }}>
              <FormGroup label="CEST">
                <InputGroup placeholder="Filtrar Cest" value={ResultadoStore.obs.filters_nao_contestados.filterCest} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterCest = e.target.value)} />
              </FormGroup>
            </th>
  
            <th style={{ width: "5%" }}>
              <FormGroup label="CNPJ">
                <InputGroup placeholder="Filtrar CNPJ" value={ResultadoStore.obs.filters_nao_contestados.filterDestino} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterDestino = e.target.value.replace(/[^0-9]/g, ''))} />
              </FormGroup>
            </th>
  
            <th style={{ width: "15%" }}>
              <FormGroup label="Descrição">
                <InputGroup placeholder="Filtrar Descrição" value={ResultadoStore.obs.filters_nao_contestados.filterDescricao} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterDescricao = e.target.value)} />
              </FormGroup>
            </th>
  
            <th style={{ width: "15%" }}>
              <FormGroup label="Chave">
                <InputGroup placeholder="Filtrar Chave" value={ResultadoStore.obs.filters_nao_contestados.filterChave} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterChave = e.target.value)} />
              </FormGroup>
            </th>
          </tr>
        </thead>

        <div>
          {/* @ts-ignore */}
          <BootstrapTable keyField="id" className="TableDefault" data={items_new} columns={this.obs.new_columns} selectRow={selectRowProp} hover />
        </div>

      </>
    );
  }
}

export default NaoContestadosTableRs;
